import api from '@/services/api';
import { useState } from 'react';
export interface FileData {
  name: string;
  data: string; // Base64 string
}

export interface ModelData {
  name: string;
  description: string;
  suggested_prompts: string[];
  tools?: string[];
  mcp_servers?: string[];
  files?: FileData[];
  order: number;
  model?: string;
  logo?: string;
  logo_file?: FileData;
  tool_settings?: Record<string, Record<string, unknown>>;
  custom_data?: { foundry_agent?: string };
}

export const useRegisterAssistant = () => {
  const [assistant, setAssistant] = useState<ModelData | null>(null);

  const registerAssistant = async (assistant: ModelData) => {
    const response = await api.post('/api/v1/assistants/', assistant);
    setAssistant(response.data);
  };

  return { assistant, registerAssistant };
};
